import React from "react";
import { observer } from "mobx-react";
import StatTile from "../visuals/StatTile";

/**
 * 2–4 stat tiles in a grid. Composes StatTile rather than restating tile
 * markup, so a change to delta or number formatting lands in both.
 *
 * Capped at 4: past that the row stops reading as "the headline numbers" and
 * becomes wallpaper. The agent is told to send the rest as a table.
 */
const MAX_TILES = 4;

const KpiRowBlock = observer(({ block }) => {
  const tiles = (block.tiles || []).slice(0, MAX_TILES);
  if (!tiles.length) return null;

  return (
    <div className="cpVisual">
      {block.title && <div className="cpVisual__title">{block.title}</div>}
      <div className={`cpKpiRow cpKpiRow--${tiles.length}`}>
        {tiles.map((tile, index) => (
          <StatTile
            key={tile.label || index}
            label={tile.label}
            value={tile.value}
            unit={tile.unit}
            decimals={tile.decimals}
            delta={tile.delta}
            footnote={tile.footnote}
            sparkline={tile.sparkline}
            size={tiles.length > 2 ? "sm" : "md"}
          />
        ))}
      </div>
    </div>
  );
});

export default KpiRowBlock;
